import * as React from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var supportWebp = !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
var addSupportWebpClass = function (className) {
    if (supportWebp) {
        document.body.classList.add(className || 'webp');
    }
};
var getImageResizeUrl = function (url, notCheckSuffix) {
    if (!url || !supportWebp) {
        return url;
    }
    if (!notCheckSuffix && !/\.(jpe?g|png)/.test(url)) {
        return url;
    }
    // 如果非gift3图片资源，或者已经有参数，则直接返回
    if (!(url.includes('s3-us01.didiglobal.com') || url.includes('s3-us01-public.didiglobal.com') || url.includes('s3-us01-public-inter.didiglobal.com'))
        || url.includes('x-s3-process=image/')) {
        return url;
    }
    return "".concat(url).concat(url.includes('?') ? '&' : '?', "x-s3-process=image/format,webp");
};
var ReactImageForGiftV3 = React.forwardRef(function (props, ref) {
    var src = props.src, onError = props.onError, notCheckSuffix = props.notCheckSuffix, rest = __rest(props, ["src", "onError", "notCheckSuffix"]);
    var onErrorHandler = function (e) {
        var elem = e.target;
        var dataset = elem.dataset;
        var originurl = dataset === null || dataset === void 0 ? void 0 : dataset.originurl;
        if (elem && elem instanceof HTMLImageElement && elem.tagName.toLowerCase() === 'img' && originurl) {
            elem.setAttribute('data-originurl', '');
            elem.src = originurl;
        }
        onError && onError(e);
    };
    var imgSrc = supportWebp ? getImageResizeUrl(src || '', notCheckSuffix) : src;
    return React.createElement("img", __assign({ ref: ref, "data-originurl": src, src: imgSrc, onError: onErrorHandler }, rest));
});

var VueImageForGiftV3 = {
    props: {
        src: {
            type: String,
            default: ''
        },
        notCheckSuffix: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        restProps: function () {
            var _a = this.$props, src = _a.src, notCheckSuffix = _a.notCheckSuffix, rest = __rest(_a, ["src", "notCheckSuffix"]);
            var error = this.$listeners.error;
            rest['data-originurl'] = src;
            return __assign({ src: supportWebp ? getImageResizeUrl(src || '', notCheckSuffix) : src, onimgerror: function () {
                    var e = arguments[0];
                    var elem = e.target;
                    var dataset = elem.dataset;
                    var originurl = dataset === null || dataset === void 0 ? void 0 : dataset.originurl;
                    if (elem && elem instanceof HTMLImageElement && elem.tagName.toLowerCase() === 'img' && originurl) {
                        elem.setAttribute('data-originurl', '');
                        elem.src = originurl;
                    }
                    error && error(e);
                } }, rest);
        },
    },
    // template: "<img v-bind='restProps' />"
    render: function (h) {
        var _a = this.restProps, onimgerror = _a.onimgerror, rest = __rest(_a, ["onimgerror"]);
        return h('img', {
            attrs: rest,
            on: __assign(__assign({}, this.$listeners), { error: onimgerror })
        });
    },
};

export { ReactImageForGiftV3, VueImageForGiftV3, addSupportWebpClass, getImageResizeUrl, supportWebp };
